import { Box, Typography } from "@mui/material";
import { useRef } from "react";
import { useCaseCreationStore } from "../../../../store/useCaseCreationStore";
import BodyLocationForm from "../../components/forms/BodyLocationForm";
import DeceasedDetailsForm from "../../components/forms/DeceasedDetailsForm";
import Documents from "../../components/forms/Documents";

export default function RemovalDeceasedLocation({ onBack, onNext }: any) {
  const {
    deceasedDetails,
    setDeceasedDetails,
    deceasedLocation,
    setDeceasedLocation,
  } = useCaseCreationStore();
  const deceasedValidationRef = useRef<(() => boolean) | null>(null);
  const locationValidationRef = useRef<(() => boolean) | null>(null);

  const validateStageOneDetails = () => {
    const deceasedValid = deceasedValidationRef.current?.() ?? false;
    const locationValid = locationValidationRef.current?.() ?? false;
    return deceasedValid && locationValid;
  };

  return (
    <Box>
      <Typography fontSize={18} fontWeight={800} mt={2.5} mb={-1}>
        Deceased Details
      </Typography>
      <DeceasedDetailsForm
        deceasedDetails={deceasedDetails}
        setDeceasedDetails={setDeceasedDetails}
        minimalCapture
        hideActions
        validationRef={deceasedValidationRef}
      />

      <Typography fontSize={18} fontWeight={800} mt={2.5} mb={-1}>
        Body Location and Removal Remarks
      </Typography>
      <BodyLocationForm
        deceasedLocation={deceasedLocation}
        setDeceasedLocation={setDeceasedLocation}
        minimalCapture
        hideActions
        validationRef={locationValidationRef}
      />

      <Documents
        onBack={onBack}
        onNext={onNext}
        minimalCapture
        hideUploader
        beforeSubmit={validateStageOneDetails}
      />
    </Box>
  );
}
